module.exports = __webpack_public_path__ + "img/6.4a8bb55c.svg";